import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FloatingLabel,
  Row,
  Col,
  ProgressBar,
  ListGroup,
  Badge,
} from "react-bootstrap";
import { useLocation, useParams } from "react-router-dom";
import qs from "qs";
import styled from "styled-components";
import { getUserSession } from "../component/userInfo";
import NextgenPhotoItem from "./NextgenPhotoItem";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const MyInput = styled.div`
  .photo-input {
    position: relative;
    padding: 1rem;
    border: 0.2rem solid #ececec;
    border-radius: 8px;
    margin-right: 0;
    margin-left: 0;
    color: #212529;
  }
`;

const MyButton = styled.div`
  .close-delete {
    padding: 12px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
`;

function getExten(str) {
  //console.log("getExten :: " + str);
  let aa = str.split(".");
  return aa[aa.length - 1];
}

const NextgenPhotoForm = () => {
  const location = useLocation();
  const { photoType } = useParams();

  const getTitle = (type) => {
    switch (type) {
      case "kobi":
        return "영유아부";
      case "koch":
        return "유치부";
      case "koki":
        return "어린이부";
      case "koding":
        return "청소년부";
      default:
        return "다음세대";
    }
  };

  const [submitProcessing, setSubmitProcessing] = useState(false);
  const [progressRate, setProgressRate] = useState(0);
  const [progressLabel, setProgressLabel] = useState("");

  const [selectedFileList, setSelectedFileList] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [photoFiles, setPhotoFiles] = useState([]);
  const [photoNo, setPhotoNo] = useState();

  const [maxWidth, setMaxWidth] = useState("150");

  const [isRegMode, setIsRegMode] = useState(true);
  const [filekey, setFilekey] = useState(
    (Math.floor(Math.random() * 1000000) + 1000000 + "").substring(1)
  );

  const [selected, setSelected] = useState();

  useEffect(() => {
    // const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    // if (query.photoNo) {
    //   fetchPhotoInfo(query.photoNo);
    // } else {
    //   setIsRegMode(true);
    // }
    fetchPhotoInfo(photoType);
  }, [photoType]);

  const fetchPhotoInfo = (photoType) => {
    const userSession = getUserSession();
    const formData = new FormData();
    formData.append("uid", userSession.uid);
    formData.append("action", "photoList");
    formData.append("photoType", photoType);
    fetch("https://work.wekoinonia.org/json/nextgenPhoto.php", {
      method: "POST",
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        if (json.code !== "0000") {
          alert(json.msg);
        } else if (json.isreg === "N") {
          if (selected !== photoType) setSelected(photoType);
          setPhotoFiles([]);
          setSelectedFileList([]);
          setIsRegMode(true);
        } else if (json.filecount === 0) {
          if (selected !== photoType) setSelected(photoType);
          setPhotoFiles([]);
          setSelectedFileList([]);
          setIsRegMode(false);
        } else {
          setPhotoFiles(json.filelist);
          setSelectedFileList([]);
          setIsRegMode(false);
        }
      })
      .catch((error) => console.error("Error:", error));
  };

  const onSubmit = (event) => {
    event.preventDefault();
    saveForm(event);
  };

  const uploadImageImgbb = async (imgfile) => {
    var form = new FormData();
    form.set("key", process.env.REACT_APP_IMGBB_API_KEY);
    form.append("image", imgfile);
    var url = "https://api.imgbb.com/1/upload";
    const config = { method: "POST", mode: "cors", body: form };
    const response = await fetch(url, config);
    return await response.json();
  };

  const saveForm = async () => {
    if (submitProcessing) return;
    setSubmitProcessing(true);
    const userSession = getUserSession();
    setProgressRate(0);
    setProgressLabel(`0 / ${selectedFileList.length}`);
    let sendCount = 0;

    for (const selectedFile of selectedFileList) {
      try {
        const json = await uploadImageImgbb(selectedFile);
        const formData = new FormData();
        formData.append("path", "nextgen_photo");
        formData.append("uid", userSession.uid);
        formData.append("filekey", filekey);
        formData.append("file_size", json.data.size);
        formData.append("file_name", json.data.image.filename);
        formData.append("file_type", json.data.image.mime);
        formData.append("url", json.data.url);
        formData.append(
          "medium_url",
          json.data.medium ? json.data.medium.url : ""
        );
        formData.append("thumb_url", json.data.thumb.url);
        formData.append("imgbb_info", JSON.stringify(json));
        formData.append("photo_type", photoType);
        formData.append("photo_index", photoFiles.length + sendCount);

        const response = await fetch(
          "https://work.wekoinonia.org/json/nextgenPhotoLinkSave.php",
          {
            method: "POST",
            body: formData,
            mode: "cors",
          }
        );
        const result = await response.json();
        if (result.code !== "0000") {
          throw new Error(result.msg);
        }
        sendCount++;
        setProgressRate((sendCount * 100) / selectedFileList.length);
        setProgressLabel(`${sendCount} / ${selectedFileList.length}`);
      } catch (error) {
        setSubmitProcessing(false);
        console.error("Error:", error);
        alert("Upload failed: " + error.message);
        return;
      }
    }

    try {
      const photoTempList = photoFiles.map((item, index) => ({
        photo_file_no: item.photo_file_no,
        photo_index: index,
      }));
      const photodata = JSON.stringify(photoTempList);

      const formData = new FormData();
      formData.append("uid", userSession.uid);
      formData.append("action", "save");
      formData.append("photoType", photoType);
      formData.append("filekey", filekey);
      formData.append("photoListData", photodata);

      fetch("https://work.wekoinonia.org/json/nextgenPhoto.php", {
        method: "POST",
        body: formData,
        mode: "cors",
      })
        .then((res) => res.json())
        .then((json) => {
          setSubmitProcessing(false);
          alert(json.msg);
          window.location.replace("/");
        })
        .catch((error) => {
          setSubmitProcessing(false);
          console.error("Error:", error);
        });
    } catch (error) {
      setSubmitProcessing(false);
      alert(error.code + "\n" + error.message);
    }
  };

  const changeHandler = (event) => {
    let files = Array.from(event.target.files);
    setSelectedFileList([...selectedFileList, ...files]);
    event.target.value = null;
    setIsSelected(true);
  };

  const movePhotoItem = (dragIndex, hoverIndex) => {
    const updatedPhotoFiles = [...photoFiles];
    const [moved] = updatedPhotoFiles.splice(dragIndex, 1);
    updatedPhotoFiles.splice(hoverIndex, 0, moved);
    setPhotoFiles(updatedPhotoFiles);
  };

  return (
    <section className="container">
      <h1>
        {getTitle(photoType)} 사진 {isRegMode ? "등록" : "수정"}
      </h1>
      <MyInput>
        <div className="photo-input">
          <DndProvider backend={HTML5Backend}>
            <Form onSubmit={onSubmit} className="mb-4">
              <input type="hidden" name="filekey" value={filekey} />
              {submitProcessing ? (
                <ProgressBar
                  animated
                  now={progressRate}
                  label={progressLabel}
                />
              ) : (
                <div>
                  <Row>
                    <Col>
                      <Button variant="primary" type="submit" className="w-100">
                        저장
                      </Button>
                    </Col>
                    <Col></Col>
                  </Row>

                  <label htmlFor="customRange2" className="form-label pt-3">
                    사진크기 (사진을 작게 조정하면 끌어붙이기로 순서를 변경할 수
                    있습니다. 변경후 꼭 저장을 클릭해 주세요)
                  </label>
                  <input
                    type="range"
                    className="form-range"
                    min="150"
                    max="640"
                    id="customRange2"
                    step="2"
                    value={maxWidth}
                    onChange={(e) => setMaxWidth(e.target.value)}
                  />
                </div>
              )}
            </Form>
            <Row>
              {photoFiles.map((photoFile, index) => (
                <NextgenPhotoItem
                  imageInfo={photoFile}
                  photoType={photoType}
                  key={index}
                  index={index}
                  movePhotoItem={movePhotoItem}
                  width={maxWidth}
                  reloadPhotoList={() => fetchPhotoInfo(photoType)}
                />
              ))}
            </Row>
          </DndProvider>
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label>첨부파일</Form.Label>
            <Form.Control
              type="file"
              onChange={changeHandler}
              title=" "
              style={{ display: "inline" }}
              multiple
            />
          </Form.Group>
          {isSelected ? (
            <div>
              <h5>
                업로드 대상 파일{" "}
                <Badge bg="secondary">{selectedFileList.length}</Badge>건{" "}
              </h5>
              <ListGroup>
                {selectedFileList.map((selectedFile) => (
                  <ListGroup.Item key={selectedFile.name}>
                    <i
                      className={
                        "bi bi-filetype-" + getExten(selectedFile.name)
                      }
                    ></i>
                    <img
                      src={URL.createObjectURL(selectedFile)} // 바로 이 부분입니다.
                      alt={selectedFile.name}
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        marginRight: "10px",
                      }}
                    />
                    {selectedFile.name},{selectedFile.size}
                    {/*selectedFile.lastModifiedDate.toLocaleDateString()*/}
                    <Badge
                      bg="danger"
                      pill
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        setSelectedFileList(
                          selectedFileList.filter(
                            (f) => f.name !== selectedFile.name
                          )
                        )
                      }
                    >
                      X
                    </Badge>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          ) : (
            <p>첨부하실 이미지를 선택하십시오 </p>
          )}{" "}
        </div>
      </MyInput>
    </section>
  );
};

export default NextgenPhotoForm;
